import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

/**
 * Floating conversion CTA that appears once the user has scrolled past the hero.
 * Hidden when the Contact section is in view (to avoid double-CTA noise).
 */
export default function StickyCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const contact = document.getElementById("contact");
      const scrolled = window.scrollY > 600;
      let overContact = false;
      if (contact) {
        const rect = contact.getBoundingClientRect();
        overContact = rect.top < window.innerHeight * 0.85;
      }
      setVisible(scrolled && !overContact);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToContact = () => {
    const el = document.getElementById("contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          key="sticky-cta"
          data-testid="sticky-cta"
          data-cursor="Let's build"
          onClick={scrollToContact}
          initial={{ opacity: 0, y: 30, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 30, scale: 0.9 }}
          transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-5 right-5 md:bottom-8 md:right-8 z-40 inline-flex items-center gap-3 px-5 py-3.5 rounded-full bg-[#E2FF31] text-black font-display font-semibold shadow-[0_20px_60px_-10px_rgba(226,255,49,0.6)] hover:scale-[1.03] transition-transform"
        >
          <span className="relative flex h-2.5 w-2.5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-black opacity-40" />
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-black" />
          </span>
          Start a project
          <ArrowUpRight size={18} />
        </motion.button>
      )}
    </AnimatePresence>
  );
}
